export default Object.freeze({
  PendienteDeVoucher: 1,
  VoucherRegistrado: 2,
  Pagado: 3,
});
